import {
  ascend,
  descend,
  find,
  sortWith
} from 'ramda';
import {
  LadderPipe,
  Ladders,
  PipeUsage,
  SpoolClass
} from './types';

// Equal ratings prefer the wider bore, which costs less friction.
const sortLadder = sortWith<LadderPipe>([
  ascend((pipe) => pipe.pressureRating),
  descend((pipe) => pipe.insideDiameter),
  ascend((pipe) => pipe.name),
]);

const ladderFor = (spoolClass: SpoolClass, pipes: LadderPipe[], usage: Record<string, PipeUsage>) => sortLadder(
  pipes.filter((pipe) => usage[pipe.pipeId] === spoolClass),
);

export const buildLadders = (pipes: LadderPipe[], usage: Record<string, PipeUsage>): Ladders => ({
  level: ladderFor('level', pipes, usage),
  borehole: ladderFor('borehole', pipes, usage),
});

// The current pipe need not be on the ladder: anything rated above it is a step up.
export const nextPipe = (ladder: LadderPipe[], currentRating: number): LadderPipe | undefined => find(
  (pipe: LadderPipe) => pipe.pressureRating > currentRating,
  ladder,
);
